export default {"src":"/_next/static/media/fitness.41218f4c.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};